import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedSalesforceApp from "./EmbeddedSalesforceApp";
const SalesforceApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("salesforce.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("salesforce.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedSalesforceApp, null));
};
export default SalesforceApp;
